import LocomotiveScroll from 'locomotive-scroll'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class FullPageScroll 
{
  constructor()
  {
    this.connectToScrollTrigger()
  }

  connectToScrollTrigger()
  {
      this.scroller = document.querySelector("[data-scroll-container]")
      const scroller = this.scroller
      const locoScroll = new LocomotiveScroll(
        {
          el: scroller,
          smooth: false,
          multiplier: 0.85,
          smartphone: {
            smooth: false,
            direction: 'vertical'
          },
          tablet: {
            smooth: false,
            direction: 'vertical'
          }
        }
      )

      locoScroll.on("scroll", ScrollTrigger.update)

      ScrollTrigger.scrollerProxy(scroller,
        {
          scrollTop(value) {
            return arguments.length ?
            locoScroll.scrollTo(value, 0, 0) :
            locoScroll.scroll.instance.scroll.y 
          },
          getBoundingClientRect() {
            return {top: 0, left: 0, width:
            window.innerWidth, height: window.innerHeight}
          },
          pinType: scroller.style.transform ? "transform" : "fixed"
        })
    
        ScrollTrigger.addEventListener('refresh', () =>
          locoScroll.update())
    
        ScrollTrigger.refresh()

        // document.addEventListener('DOMContentLoaded', function(){
        //   function ScrollUpdateDelay() {
        //     setTimeout(function(){locoScroll.update()}, 5000)
        //   }

        //   ScrollUpdateDelay()
        // })
  }
}